<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
      closeable
      close-icon-position="top-right"
      :close-on-click-overlay="false"
      @closed="resetForm"
  >
    <div class="modal-container">
      <div class="modal-title">申请耗材</div>
      <van-form @submit="onSubmit">
        <van-field
            v-model="form.deviceType"
            name="deviceType"
            label="耗材类型"
            placeholder="请选择耗材类型"
            :rules="[{ required: true, message: '请选择耗材类型' }]"
            readonly
            @click="showDeviceTypePicker = true"
        >
          <template #right-icon>
            <van-icon name="arrow-down" />
          </template>
        </van-field>

        <van-popup
            v-model="showDeviceTypePicker"
            round
            position="bottom"
        >
          <van-picker
              show-toolbar
              title="选择耗材类型"
              :columns="deviceTypeOptions"
              values="text"
              @confirm="onDeviceTypeConfirm"
              @cancel="showDeviceTypePicker = false"
          />
        </van-popup>

        <van-field
            v-model="form.deviceNumber"
            name="deviceNumber"
            label="数量"
            placeholder="请输入数量"
            :rules="[{ required: true, message: '请输入数量' }]"
        />

        <van-field
            v-model="form.faultType"
            name="faultType"
            label="申请原因"
            placeholder="请选择申请原因"
            :rules="[{ required: true, message: '请选择申请原因' }]"
            readonly
            @click="showFaultTypePicker = true"
        >
          <template #right-icon>
            <van-icon name="arrow-down" />
          </template>
        </van-field>

        <van-popup
            v-model="showFaultTypePicker"
            round
            position="bottom"
        >
          <van-picker
              show-toolbar
              title="选择申请原因"
              :columns="faultTypeOptions"
              values="text"
              @confirm="onFaultTypeConfirm"
              @cancel="showFaultTypePicker = false"
          />
        </van-popup>

        <van-field
            v-model="form.faultDescription"
            name="faultDescription"
            label="备注说明"
            type="textarea"
            placeholder="请输入备注说明(选填)"
            rows="3"
            autosize
        />
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="cancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit">提交申请</van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>

<script>
import * as imageConversion from "image-conversion";
export default {
  name: 'RepairModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.value,
      showDeviceTypePicker: false,
      showFaultTypePicker: false,
      showUrgencyPicker: false,
      form: {
        deviceType: '',
        deviceNumber: '',
        faultType: '',
        faultDescription: '',
      },
      deviceTypeOptions: [
        {id:1,text:'热敏纸'},
        {id:2,text:'色带'},
        {id:3,text:'清洁套装'},
        {id:4,text:'维护工具'},
        {id:5,text:'其他'}
      ],
      faultTypeOptions: [
        {id:1,text:'定期补充'},
        {id:2,text:'库存不足'},
        {id:3,text:'质量问题'},
        {id:4,text:'其他'}
      ],
    }
  },
  watch: {
    value(val) {
      this.showPopup = val
    },
    showPopup(val) {
      this.$emit('input', val)
    }
  },
  methods: {

    onDeviceTypeConfirm(value) {
      this.form.deviceType = value.text;
      this.showDeviceTypePicker = false;
    },
    onFaultTypeConfirm(value) {
      this.form.faultType = value.text;
      this.showFaultTypePicker = false;
    },
    onUrgencyConfirm(value) {
      this.form.urgency = value.text;
      this.showUrgencyPicker = false;
    },
    onSubmit() {
      this.$emit('submit', { ...this.form })
    },
    cancel() {
      this.showPopup = false
    },
    resetForm() {
      this.form = {
        deviceType: '',
        deviceNumber: '',
        faultType: '',
        faultDescription: '',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
